import { render, staticRenderFns } from "./DoughnutChart.vue?vue&type=template&id=027b3cea&scoped=true&"
import script from "./DoughnutChart.vue?vue&type=script&lang=ts&"
export * from "./DoughnutChart.vue?vue&type=script&lang=ts&"
import style0 from "./DoughnutChart.vue?vue&type=style&index=0&id=027b3cea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027b3cea",
  null
  
)

export default component.exports